<template>
	<div>
		<v-snackbar
			v-model="dialog.snackbar"
			top
			right
			color="green">
			<span 
				class="body-1 font-weight-light white--text"
				v-html="message.success">
			</span>

			<template v-slot:action="{ attrs }">
				<v-btn
					icon
					color="white"
					class="body-1 font-weight-bold text-capitalize"
					v-bind="attrs"
					@click="dialog.snackbar = false">
					<v-icon>mdi-close-circle-outline</v-icon>
				</v-btn>
			</template>
		</v-snackbar>
		<v-dialog v-model="dialog.form"
			@keydown.esc="dialog.form = false"
			:fullscreen="dialog.fullscreen"
			width="600"
			persistent
			scrollable>
			<v-card 
				:class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
				<v-card-title 
					class="d-flex align-center px-4 py-2 text-right popup-header">
					<div
						class="fs-16 font_weight_700">
						{{ form.id === '' ? 'Tambah' : 'Ubah' }} Dokumen Siswa
					</div>

					<v-spacer/>

					<!-- <v-icon 
						@click="dialog.fullscreen = !dialog.fullscreen ? true : false"
						class="cursor-pointer mr-1"
						size="24"
						:color="set_color">
						{{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
					</v-icon> -->

					<v-icon 
						@click="dialog.form = false; dialog.fullscreen = false;"
						class="cursor-pointer"
						size="22"
						color="#9ca3af">
						mdi-close
					</v-icon>
				</v-card-title>

				<v-divider 
					class="mt-0"
					style="border-top: 1px solid #e0e0e0;"/>

				<v-card-text 
					class="py-0 my-4">
					<ValidationObserver 
						ref="form">
						<v-form>
							<v-row>
								<v-col cols="12" md="12">
									<ValidationProvider 
										name="Keterangan"
										rules="required"  
										v-slot="{ errors }">
										<div class="fs-13 mb-1">
											
											Keterangan
											<span class="red--text">*</span>
										</div>

										<v-autocomplete
											v-on:keyup.enter="save()"

											solo
											rounded
											dense

											:color="set_color"
											placeholder="Keterangan"
											v-on:change="form.title = form.category === 'Lainnya' ? '' : form.category"

											:items="[
												'Pas Foto', 'Akte Kelahiran', 'Kartu Keluarga', 'KTP Ayah Kandung', 'KTP Ibu Kandung', 'Kartu Pelajar', 'Lainnya'
											]"
											:item-color="set_color"

											v-model="form.category"
											class="mb-0"
											:error-messages="errors"
											required
											style="border-radius: 10px;">
										</v-autocomplete>
									</ValidationProvider>

									<div v-if="form.category === 'Lainnya'">
										<ValidationProvider 
											name="Keterangan Lainnya"
											rules="required"  
											v-slot="{ errors }">
											<div class="fs-13 mb-1">
												Keterangan Lainnya
												<span class="red--text">*</span>
											</div>

											<v-text-field
												v-on:keyup.enter="save()"

												solo
												rounded
												dense

												:color="set_color"
												placeholder="Keterangan Lainnya"

												v-model="form.title"
												class="mb-0"
												:error-messages="errors"
												required
												style="border-radius: 10px;">
											</v-text-field>
										</ValidationProvider>
									</div>
									<div class="mb-0 font_weight_600 fs-14 black_one d-flex align-center mb-3">
										<div class="mr-3">
											<uploadimage
												v-model="upload.image" >
												<div 
													slot="activator"
													class="cursor-pointer">
													<v-btn
														color="#4B4B4B"
														elevation="0"
														small
														:disabled="process.image"
														:loading="process.image"
														min-height="30"
														class="fs-12 white--text text-capitalize d-flex align-center"
														style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
														<v-icon size="15">mdi-cloud-upload-outline</v-icon>
														
														<span
															class="ml-2 ">
															Tambah Gambar
														</span>
													</v-btn>
												</div>
											</uploadimage>
										</div>
										<div class="mr-3">
											<uploadfile
												v-model="upload.document" >
												<div 
													slot="activator"
													class="cursor-pointer">
													<v-btn
														color="primary"
														elevation="0"
														small
														:disabled="process.document"
														:loading="process.document"
														min-height="30"
														class="fs-12 white--text text-capitalize d-flex align-center"
														style="border-radius: 6px; font-weight: 600;">
														<v-icon size="15">mdi-file-document</v-icon>
														
														<span
															class="ml-2 ">
															Tambah File
														</span>
													</v-btn>
												</div>
											</uploadfile>
										</div>
									</div>

									<div v-if="form.url !== ''">
										<div class="fs-13 mb-1">
											Preview
										</div>
										<div v-if="extension_file(form.url) === 'pdf'">
											<a
												:href="form.url"
												target="_blank"
												class="d-flex align-center">
												<v-icon size="25" color="red">mdi-file-pdf</v-icon>
												
												<span
													class="ml-2">
													{{ form.url.split('/')[6] }}
												</span>
											</a>
										</div>
										<div v-else>
											<img
												:src="form.url"
												:alt="form.title"
												style="width: 100%; height: auto; border-radius: 10px;" />
										</div>
									</div>

								</v-col>
							</v-row>
						</v-form>
					</ValidationObserver>

				</v-card-text>
				
				<v-divider 
					class="mt-2"
					style="border-top: 1px solid #e0e0e0;"/>
				
				<v-card-actions
					class="pa-4">
					<div v-if="message.error.length > 0"
						class="text-left mt-0">
						<div
							class="error--text d-flex align-start">
							<v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
							
							<span
								class="ml-1">
								{{ message.error }}
							</span>
						</div>
					</div>
					<v-spacer/>

					<v-btn
						@click="save()"
						:loading="process.form"
						:disabled="process.form"
						width="85"
						elevation="0"
						:color="set_color"
						style="border-radius: 6px;"
						class="fs-13 font-weight-bold text-capitalize white--text">
						Simpan
					</v-btn>

					<v-btn
						@click="dialog.form = false; reset();"
						:disabled="process.form"
						width="85"
						outlined
						elevation="0"
						color="red"
						style="border-radius: 6px;"
						class="fs-13 font-weight-bold text-capitalize white--text">
						Batal
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialog.delete"
			@keydown.esc="dialog.delete = false"
			:fullscreen="dialog.fullscreen"
			width="500"
			persistent
			scrollable>
			<v-card 
				:class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
				<v-card-title 
					class="d-flex align-center pa-4 text-right popup-header">
					Hapus Data

					<v-spacer/>

					<v-icon 
						@click="dialog.fullscreen = !dialog.fullscreen ? true : false"
						class="cursor-pointer mr-1"
						size="24"
						:color="set_color">
						{{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
					</v-icon>

					<v-icon 
						@click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
						class="cursor-pointer"
						size="24"
						color="red">
						mdi-close-circle-outline
					</v-icon>
				</v-card-title>
				
				<v-divider 
					class="mb-2"
					style="border-top: 2px dashed #e0e0e0;"/>

				<v-card-text 
					class="body-1 font-weight-light text-first line-text-second mt-4">
					Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
				</v-card-text>

				<div v-if="message.error.length > 0"
					class="text-center mx-6 my-4">
					<div
						class="error--text d-flex align-start">
						<v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
						
						<span
							class="ml-1">
							{{ message.error }}
						</span>
					</div>
				</div>

				<v-divider 
					class="mt-2"
					style="border-top: 2px dashed #e0e0e0;"/>

				<v-card-actions
					class="pa-4">
					<v-spacer/>

					<v-btn
						rounded
						width="120"
						@click="deletes()"
						:loading="process.delete"
						:disabled="process.delete"
						color="green"
						elevation="0"
						class="body-2 font-weight-bold text-capitalize white--text">
						Ya, Hapus
					</v-btn>

					<v-btn
						rounded
						width="120"
						@click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
						:disabled="process.delete"
						outlined
						class="body-2 font-weight-bold text-capitalize red--text">
						Batal
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<div>
			<div class="fs-13 font_weight_600  black--text d-flex justify-space-between align-start" style="margin-bottom: 5px;">
				<div>
					Data Dokumen
				</div>
				<div>
					<v-btn
						:disabled="process.form"
						dark
						elevation="0"
						small
						@click="dialog.form = true; reset();"
						:color="set_color"
						class="white--text text-capitalize"
						style="border-radius: 6px;">
						Tambah
					</v-btn>
				</div>
			</div>
			
			<div  class="mx-1">
				<table style="border: none; width: 100%; border-collapse: collapse;">
					<tr>
						<th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: center; width: 1px; white-space: nowrap;" class="black--text">
							Aksi
						</th>
						<th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
							Link
						</th>
						<th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
							Keterangan
						</th>
					</tr>

					<tr v-for="(item, index) in list" :key="index">
						<td style="padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;">

							<v-tooltip 
								top>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										@click="reset(item); dialog.form = true;"
										
										v-bind="attrs"
										v-on="on"

										min-width="25"
										height="25"
										x-small
										rounded
										color="#3b3f5c"
										elevation="0"
										class="white--text text-capitalize mx-1 px-0"
										style="font-weight: 600; border-radius: 8px;">
										<v-icon size="13">mdi-pencil-outline</v-icon>
									</v-btn>
								</template>

								<span>Ubah</span>
							</v-tooltip>

							<v-tooltip 
								top>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										@click="toDelete(item.id)"

										v-bind="attrs"
										v-on="on"

										min-width="25"
										height="25"
										x-small
										rounded
										color="#e7515a"
										elevation="0"
										class="white--text text-capitalize mx-1 px-0"
										style="font-weight: 600; border-radius: 8px;">
										<v-icon size="13">mdi-trash-can-outline</v-icon>
									</v-btn>
								</template>
								
								<span>Hapus</span>
							</v-tooltip>
						</td>
						<td style="padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;">
							<!-- <div v-if="extension_file(item.url) === 'pdf'">
								<a
									:href="item.url"
									target="_blank"
									class="d-flex align-center">
									<v-icon size="20" color="red">mdi-file-pdf</v-icon>
									
									<span
										class="ml-2">
										{{ item.url }}
									</span>
								</a>
							</div>
							<div v-else>
								<img
									:src="item.url"
									:alt="item.title"
									style="width: 100px; height: auto; border-radius: 10px;" />
							</div> -->
							<v-tooltip 
								top>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										:href="item.url"
										target="_blank"
										
										v-bind="attrs"
										v-on="on"
										
										min-width="24" min-height="24"
										x-small
										rounded
										:color="extension_file(item.url) === 'pdf' ? '#b40c1d' : 'indigo'"
										elevation="0"
										class="white--text text-capitalize mx-1 px-0"
										style="font-weight: 600; border-radius: 6px;">
										<v-icon size="15">{{ extension_file(item.url) === 'pdf' ? 'mdi-file-pdf' : 'mdi-image-area' }}</v-icon>
									</v-btn>
								</template>

								<span>Lihat</span>
							</v-tooltip>
						</td>
						<td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
							{{ item.title }}
						</td>
					</tr>
				</table>
				<v-card-text
					v-if="list.length === 0"
					class="pb-0 mb-4" style="height: 200px; display: flex; align-items: center; justify-content: center; border: 1px solid #eee; border-top: none;">
					<div class="text-center">
						<div class="mt-3 fs-16">
							Belum ada data
						</div>
					</div>
				</v-card-text>
			</div>
		</div>
	</div>
</template>

<script>
	import { TokenService } from "@/service/Storage.Service";
	import { get, post, put, patch, destroy } from "@/service/Axios";
	import axios from "axios";
	import moment from "moment"
	import "moment/locale/id"
	export default {
		data () {
			return {
				form: {
					title: '',
					url: '',
					desc: '',
					id: '',
					category: '',
				},
				process: {
					load: false,
					form: false,
					delete: false,
					image: false,
					document: false,
				},
				dialog: {
					form: false,
					delete: false,
					snackbar: false,
					fullscreen: false
				},
				list: [],
				message: {
					success: '',
					error: ''
				},
				selected: {
					row: [],
					delete: []
				},
				upload: {
					image: null,
					document: null
				},
			}
		},
		props: {
			// options: {
			//   type: Object,
			//   default: () => ({})
			// }
			detail: {
				type: Object,
				default: () => ({})
			}
		},
		components: {
			uploadimage: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue'),
			uploadfile: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/document_pdf.vue')

		},
		watch: {
			'upload.image': {
				handler: function () {
					if (this.upload.image) {
						this.process.image = this.upload.image.process

						if (!this.process.image) {
							// CALLBACK FROM UPLOAD IMAGE
							
							this.form.url = this.upload.image.fileuri

							// this.save_image()
						}
					}
				},
				deep: true
			},
			'upload.document': {
				handler: function () {
					if (this.upload.document) {
						this.process.document = this.upload.document.process

						if (!this.process.document) {
							// CALLBACK FROM UPLOAD IMAGE
							
							this.form.url = this.upload.document.fileuri

							// this.save_image()
						}
					}
				},
				deep: true
			},
			// 'options': {
			//   handler () {
			//     let pagination = { row: this.limit, page: 1 }
					
			//     this.fetch(pagination)
			//   },
			//   deep: true
			// }
		},
		computed: {
			token () {
				return this.$store.state.token
			},
			user () {
				this.filter.school_id = this.$store.state.user.school_id === undefined || this.$store.state.user.school_id === null ? this.$store.state.school !== undefined && this.$store.state.school !== null && this.$store.state.school !== '' ? this.$store.state.school : '' : this.$store.state.user.school_id
				return this.$store.state.user
			},
			set_color () {
				return this.$store.state.color
			}
		},
		mounted () {
			this.fetch()
		},
		methods: {
			async fetch() {
					this.process.load = true
					let params = {
					// id: this.$route.params.id,
					school_id: this.$route.params.school_id,
					limit: 1000
				}
				let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/siswa_doc/data' : 'siswa_doc/data'

				await get(`${url}`, { params })
				.then(response => {
					let res = response.data
					
					if (res.status === 200) {
						// this.kurikulum = res.results.data
						this.list = res.results.data

						this.process.load = false
					}
				})
			},

			extension_file (file) {
				let ext = file.split('.').pop()
				return ext
			},

			reset(item) {
				if (this.$refs.form) this.$refs.form.reset()
			
				this.form = {
					id: item !== undefined ? item.id : '',
					title: item !== undefined ? item.title : '',
					url: item !== undefined ? item.url : '',
					desc: item !== undefined ? item.desc : '',
					siswa_id: this.$route.params.id,
					school_id: this.$route.params.school_id,
					category: item !== undefined ? item.title !== 'Pas Foto' && item.title !== 'Akte Kelahiran' && item.title !== 'Kartu Keluarga' && item.title !== 'KTP Ayah Kandung' && item.title !== 'KTP Ibu Kandung' && item.title !== 'Kartu Pelajar' ? 'Lainnya' : item.title : ''
				}
				this.process.form = false
				this.message.error = ''
			},

			async save () {
				this.message.error = ''

				const isValid = await this.$refs.form.validate()

				if (isValid) {
					this.process.form = true

					let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? this.form.id === '' ? 'pegawai/siswa_doc/add' : 'pegawai/siswa_doc/update' : this.form.id === '' ? 'siswa_doc/add' : 'siswa_doc/update'

					// SAVE TO REST API
					await post(url, {
						data: {
							id: this.form.id,
							title: this.form.title,
							url: this.form.url,
							desc: this.form.desc,
							siswa_id: this.form.siswa_id,
							school_id: this.form.school_id
						}
					})
					.then(response => {
						let res = response.data
						
						this.process.form = false

						if (res.status === 200) {
							this.dialog.form = false

							this.dialog.snackbar = true
							this.message.success = res.message

							this.dialog.fullscreen = false

							this.fetch()

						} else {
							this.message.error = res.message
						}
					})

				} else {
					// AUTO FOCUS ON TEXT-FIELD
					setTimeout(() => {
						const errors = Object.entries(this.$refs.form.errors)
							.map(([key, value]) => ({ key, value }))
							.filter(error => error['value'].length)
						this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
							behavior: 'smooth',
							block: 'center'
						})
					}, 10)
				}
			},

			toDelete (id) {
				this.selected.delete = [id]

				this.dialog.delete = true
			},
			async deletes () {
				this.message.error = ''

				this.process.delete = true

				let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/siswa_doc/delete' : 'siswa_doc/delete'

				await post(`${url}`, {
					data: {
						id: this.selected.delete[0]
					}
				}).then(response => {
					let res = response.data

					this.process.delete = false

					if (res.status === 200) {

						this.dialog.delete = false

						this.selected.row = []
						this.selected.delete = []
						
						this.dialog.snackbar = true
						this.message.success = res.message

						this.dialog.fullscreen = false

						this.fetch()
					} else {
						this.message.error = res.message
					}
				})
			},
		},
	}
</script>